(() => {
  const initializedSections = new WeakSet();

  const setPanelState = (item, open, animate = true) => {
    const trigger = item.querySelector('[data-additional-info-trigger]');
    const panel = item.querySelector('[data-additional-info-panel]');
    if (!trigger || !panel) return;

    if (!animate) panel.style.transition = 'none';

    if (open) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.height = '0px';
      panel.offsetHeight;
      panel.style.height = `${panel.scrollHeight}px`;
    } else {
      panel.style.height = `${panel.scrollHeight}px`;
      panel.offsetHeight;
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.height = '0px';
    }

    if (!animate) {
      panel.offsetHeight;
      panel.style.transition = '';
      if (open) panel.style.height = 'auto';
    }
  };

  const initializeSection = (section) => {
    if (initializedSections.has(section)) return;
    initializedSections.add(section);

    const items = Array.from(section.querySelectorAll('[data-additional-info-item]'));

    items.forEach((item) => {
      setPanelState(item, item.classList.contains('is-open'), false);

      item.querySelector('[data-additional-info-trigger]')?.addEventListener('click', () => {
        const shouldOpen = !item.classList.contains('is-open');

        items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            setPanelState(otherItem, false);
          }
        });

        setPanelState(item, shouldOpen);
      });

      item.querySelector('[data-additional-info-panel]')?.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'height' && item.classList.contains('is-open')) {
          event.currentTarget.style.height = 'auto';
        }
      });
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-additional-info]')) initializeSection(scope);
    scope.querySelectorAll?.('[data-additional-info]').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
